import { ContentService } from '@blk/cwp-ng-framework';

import { Formatter } from './formatter.interface';

/**
 * Append Text to the value e.g. value = 0/100, textToAppend= ' BenchMark' , Expected: 0/100 BenchMark
 *
 * @export
 * @class TextAppendFormatter
 * @implements {Formatter}
 */
export class TextAppendFormatter implements Formatter {
	constructor(
		public readonly textToAppend: string = '',
		public readonly defaultNullValue: string = '',
		public readonly defaultUndefinedValue: string = ''
	) { }
	public format(value: any, contentSvc?: ContentService): string {

		if (value === null) {
			return this.defaultNullValue;
		}

		if (typeof value === 'undefined') {
			return this.defaultUndefinedValue;
		}

		if (typeof value === 'string') {
			value = value.concat(this.textToAppend);
		}

		return value;
	}
}
